<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs6>
        <v-card>
          <v-card-title primary-title>Login</v-card-title>
          <v-card-text>
            <v-form>
              <v-flex xs6>
                <v-text-field name="domain" label="Domain" id="domain" v-model="domain"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field name="username" label="UserName" id="username" v-model="username"></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="password"
                  label="Password"
                  id="password"
                  v-model="password"
                  type="password"
                ></v-text-field>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="success" @click="login">Login</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PBXLogin",
  data() {
    return {
      domain: "500134.70.vonex.biz",
      username: "andrew",
      password: "9tr1tZUJw914"
    };
  },
  methods: {
    ...mapActions("nampt", ["pbxLogin"]),
    login() {
      this.pbxLogin({
        domain: this.domain,
        username: this.username,
        password: this.password
      })
        .then(data => {
          this.$emit("loggedIn", data);
        })
        .catch();
    }
  }
};
</script>

<style scoped>
</style>